module.exports = __webpack_public_path__ + "img/create-wallet-en.d8c9ab99.png";